import { render, staticRenderFns } from "./SessionsResult.vue?vue&type=template&id=4c56eba2&scoped=true&"
import script from "./SessionsResult.vue?vue&type=script&lang=js&"
export * from "./SessionsResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c56eba2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/sessions/SessionsResult.vue
// module id = 1533
// module chunks = 0